export default {
  fetchOfferStatuses ({ commit }) {
    return this._vm.$network_utils
      .getOfferStatuses()
      .then(response => {
        commit('setOfferStatusesList', response)
        return response
      })
      .catch(error => {
        console.error('❌ API Error fetching offer statuses:', error)
        throw error
      })
  }
}
